import { lazy, Suspense } from 'react';
import { getAccessibleFlows } from './auth';
import { AdminStats } from './components/AdminStats';
import { ComeBackLater } from './components/ComeBackLater';
import { CommandPalette } from './components/CommandPalette';
import { DashboardOverview } from './components/DashboardOverview';
import { EpisodeDebug } from './components/EpisodeDebug';
import { EpisodeList } from './components/EpisodeList';
import { EpisodeSpecify } from './components/EpisodeSpecify';
import { GoldenAdminPanel } from './components/GoldenAdminPanel';
import { Header } from './components/Header';
import { OperatorDashboard } from './components/OperatorDashboard';
import { QualityFeedback } from './components/QualityFeedback';
import { Toast } from './components/Toast';
import { UserSelection } from './components/UserSelection';
import { Viewer } from './components/Viewer';
import { FLOW, FLOW_DISPLAY_NAMES, FLOW_URLS, isTasFlow } from './constants';
import { SecPoseViewer } from './poseAdjust/SecPoseViewer';
import { SecCapReasonApp } from './seccapReason';
import { useStore } from './store';

const DataProcessAdmin = lazy(() =>
  import('./components/DataProcessAdmin').then((m) => ({ default: m.DataProcessAdmin }))
);

export function App() {
  const { mode, authUser, operator, isAdmin } = useStore();

  if (FLOW === 'seccapreason') {
    if (mode === 'accessDenied') {
      return (
        <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-brand-dark px-6 text-center text-brand-text-primary">
          <p className="text-2xl font-bold">无权访问</p>
          <p className="text-brand-text-secondary">你的账号没有访问 SecCapReason 的权限。</p>
        </main>
      );
    }
    return <SecCapReasonApp operator={operator} isAdmin={isAdmin} />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-brand-dark text-brand-text-primary">
      <Header />

      <main className="flex-1 w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 pt-24">
        {mode === 'dashboardOverview' && <DashboardOverview />}
        {mode === 'userSelect' && <UserSelection />}
        {mode === 'operatorDashboard' && <OperatorDashboard />}
        {mode === 'adminStats' && <AdminStats />}
        {mode === 'goldenAdmin' && <GoldenAdminPanel />}
        {mode === 'dataProcessAdmin' && (
          <Suspense
            fallback={
              <div className="flex items-center justify-center py-32 gap-3 text-brand-text-secondary">
                <span className="h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent" />
                <span className="text-sm">加载中…</span>
              </div>
            }
          >
            <DataProcessAdmin />
          </Suspense>
        )}
        {mode === 'qualityFeedback' && <QualityFeedback />}
        {mode === 'episodeList' && <EpisodeList />}
        {mode === 'episodeSpecify' && <EpisodeSpecify />}
        {mode === 'accessDenied' && (
          <div className="flex flex-col items-center justify-center py-32 gap-6 text-center">
            <p className="text-2xl font-bold text-brand-text-primary">无权访问</p>
            <p className="text-brand-text-secondary">你的账号没有访问此平台的权限。</p>
            {getAccessibleFlows(authUser).length > 0 && (
              <div className="flex flex-col gap-2">
                <p className="text-sm text-brand-text-secondary">你有权限访问以下平台：</p>
                {getAccessibleFlows(authUser).map((flow) => (
                  <a
                    key={flow}
                    href={FLOW_URLS[flow]}
                    className="text-brand-orange hover:underline font-semibold"
                  >
                    {FLOW_DISPLAY_NAMES[flow]}
                  </a>
                ))}
              </div>
            )}
          </div>
        )}
        {mode === 'comeBackLater' && <ComeBackLater />}
        {mode === 'episodeDebug' && <EpisodeDebug />}
        {mode === 'viewer' && (FLOW === 'secpose' ? <SecPoseViewer /> : <Viewer />)}
      </main>

      <footer className="py-6 text-center text-xs text-brand-text-secondary">
        <p>
          {isTasFlow ? 'SecTas' : 'SecShot'} &copy; {new Date().getFullYear()}
        </p>
      </footer>

      <Toast />
      <CommandPalette />
    </div>
  );
}
